/**
 * Blogs 小猪宰汁
 * Date: 2023/3/2
 * filename：zh.js
 */
export default {
  '探索': "探索",
  '招募': "招募",
  '资产': "资产",
  '绑定邮箱': "绑定邮箱",
  '后结束当前关卡': "后结束当前关卡",
  '当前关卡已结束,正在结算中!': "当前关卡已结束,正在结算中!",
  '玩法介绍': "玩法介绍",
  '充能': "充能",
  '本关我已充能': "本关我已充能",
  '邮箱地址': "邮箱地址",
  '验证码': "验证码",
  '取消': "取消",
  '提交': "提交",
  '发送验证码': "发送验证码",
  '倒计时': "倒计时",
  '邮箱地址为空': "邮箱地址为空",
  '邮箱格式不正确': "邮箱格式不正确",
  '请输入新邮箱': "请输入新邮箱",
  '邮箱绑定成功': "邮箱绑定成功",
  '修改邮箱': "修改邮箱",
  '请输入邮箱地址': "请输入邮箱地址",
  '安全验证': "安全验证",
  '玩法说明': "玩法说明",
  '购买燃料': "购买燃料",
  '可用余额': "可用余额",
  '请输入金额': "请输入金额",
  '充值': "充值",
  '发送成功': "发送成功",
  '金额不能为空': "金额不能为空",
  '金额不能为0': "金额不能为0",
  '发送金额最小为0.1': "发送金额最小为0.1",
  '充值成功': "充值成功",
  '选择充能': "选择充能",
  '充能成功': "充值成功",
  '历史': "历史",
  '没有更多了': "没有更多了",
  '闯关': "闯关",
  '燃料': "燃料",
  '奖励': "奖励",
  '关卡': "关卡",
  '状态': "状态",
  '时间': "时间",
  '预约充能': "预约充能",
  '实际充能': "实际充能",
  '类型': "类型",
  '余额': "余额",
  '您的燃料小于': '您的燃料小于',
  '为了避免影响收益，请及时补充': '为了避免影响收益，请及时补充',

  //招募页面
  '招募好友成为守护者': "招募好友成为守护者",
  '并购买基地物资即可获得分红': "并购买基地物资即可获得分红",
  '我的好友': "我的好友",
  '小区单数': "小区单数",
  '招募奖励': "招募奖励",
  '小区单数规则': "小区单数规则",
  '关闭': "关闭",
  '级别': "级别",
  '静态收入极差': "静态收入极差",
  '平级收入极差': "平级收入极差",
  '每个好友招募可赚取一级以及二级好友参与探险奖励的': "每个好友招募可赚取一级以及二级好友参与探险奖励的",
  '您': "您",
  '直推好友': "直推好友",
  '二级好友': "二级好友",
  '查看奖励规则': "查看奖励规则",
  '招募奖励以Ju币发放，可通过“我-发送”进行提现。': "招募奖励以Ju币发放，可通过“我-发送”进行提现。",
  
  //资产页面
  '今日收益': "今日收益",
  '累计收益': "累计收益",
  '我的推荐码': "我的推荐码",
  '提现': "提现",
  '兑换': "兑换",
  '基地': "基地",
  '我的代币总价值': "我的代币总价值",
  '我的算力': "我的算力",
  '历史记录': "历史记录",
  '发送至': "发送至",
  '接收来至': "接收来至",
  'Jucoin账户': "Jucoin账户",
  '确定': "确定",
  '您正在兑换': "您正在兑换",
  '至': "至",
  '得到金额': "得到金额",
  '手续费：': "手续费：",
  '每当你兑换时，将收取': "每当你兑换时，将收取",
  '的手续费': "的手续费",
  '兑换成功': "兑换成功",
  '金额': '金额',
  '我的基地': '我的基地',
  '奖励类型': '奖励类型',
  '通关收益': '通关收益',
  '通关节点收益': '通关节点收益',
  '兑换收益': '兑换收益',
  '节点补偿': '节点补偿',
  '兑换节点收益': '兑换节点收益',
  '购买': '购买',
  '一级动态奖励': '一级动态奖励',
  '二级动态奖励': '二级动态奖励',
  '团队奖励': '团队奖励',
  '成功': '成功',
  '失败': '失败',
  '已撤回': '已撤回',
  '审核拒绝': '审核拒绝',
  '待审核': '待审核',
  '审核成功': '审核成功',
  '全部': '全部',
  '兑换成': '兑换成',
  '发送': '发送',


  //我的好友
  '邀请码': '邀请码',
  '团队人数': '团队人数',
  '业绩': '业绩',
  '注册时间': '注册时间',

  '闯关成功': '闯关成功',
  '恭喜你!': '恭喜你!',
  '已通关，本轮您预约充能': '已通关，本轮您预约充能',
  '，已返还多余充能并成功获得以下奖励': '，已返还多余充能并成功获得以下奖励',
  '通关奖励': '通关奖励',

  //历史
  '加载中' : '加载中',

  //注册
  '注册': '注册',
  '邀请人推荐码': '邀请人推荐码',
  '请输入邀请码': '请输入邀请码',
  '邀请码不能为空': '邀请码不能为空',
  //闯关失败
  '闯关失败': '闯关失败',
  '很遗憾': '很遗憾',
  '关未通关，获得以下补偿': '关未通关，获得以下补偿',
  '闯关补偿': '闯关补偿',
  '兑奖池补偿': '兑奖池补偿',
  '收下': '收下',


    '时':'时',
    '天':'天',
    '分':'分',
    '秒':'秒',
    '推荐人邀请码': '推荐人邀请码',
    '退还':'退还',
    '世界':'世界'

};
